// bookingTypeLabels.js
// Centralized labels for booking types

export const BOOKING_TYPE_LABELS = {
  new: 'New',
  updated: 'Updated',
  cancelled: 'Cancelled',
};
